import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as yup from "yup";
import { Dropdown } from "react-bootstrap";

import {
  declineRequestDetails,
  approveRequestDetails,
  changeRequestDetails,
} from "app/services/AdminServices/bookingService";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import config from "config.json";
import moment from "moment";
import { FcApproval } from "react-icons/fc";
import { TiTimes } from "react-icons/ti";
import { NotificationManager } from "react-notifications";
import ApproveDate from "./Components/ChangeRequest/ApproveDate";
import DeclineDate from "./Components/ChangeRequest/DeclineDate";
import ApproveDetails from "./Components/ChangeRequest/ApproveDetails";
import DeclineDetails from "./Components/ChangeRequest/DeclineDetails";
import ApproveCancel from "./Components/ChangeRequest/ApproveCancel";
import DeclineCancel from "./Components/ChangeRequest/DeclineCancel";
import { produce } from "immer";
import usePagePermission from "app/hooks/usePagePermission";

const passengerValidationSchema = yup.object().shape({
  id: yup.number().required(),
  changePassengerList: yup.array().of(
    yup.object().shape({
      firstName: yup.string().required("First name is required"),
      lastName: yup.string().required("Last name is required"),
      title: yup.string().required("title is required"),
    })
  ),
});

const cancelValidationSchema = yup.object().shape({
  id: yup.number().required(),
  changePassengerList: yup.array().of(
    yup.object().shape({
      firstName: yup.string().required("First name is required"),
      lastName: yup.string().required("Last name is required"),
      title: yup.string().required("title is required"),
      gender: yup.string().required("gender is required"),
    })
  ),
});

const dateValidationSchema = yup.object().shape({
  id: yup.number().required(),
  departureDate: yup.string().required("Departure Date is required"),
});

const ChangeRequest = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();

  // console.log({ canAdd, canView, canEdit, canDelete });

  const { dateTimeFormat } = config;

  const [tableState, setTableState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
  });

  const [passengerDetails, setPassengerDetails] = useState({
    firstName: "",
    lastName: "",
    title: "",
    gender: "",
    departureDate: "",
    birthDate: "",
    selected: true,
  });

  const [lgShow, setLgShow] = useState(false);
  const [declineChangeShow, setDeclineChangeShow] = useState(false);
  const [show, setShow] = useState(false);
  const [declineCancelShow, setDeclineCancelShow] = useState(false);
  const [smShow, setSmShow] = useState(false);
  const [declineDateShow, setDeclineDateShow] = useState(false);

  const dateFormater = (cell) => {
    if (cell) {
      return moment(cell).format(dateTimeFormat);
    }
  };

  const acceptRequestHandler = (row) => {
    setPassengerDetails(row);
    if (row.isPassengerChangeReq === true) {
      handleShows();
    } else if (row.isTicketCancelReq === true) {
      handleShow();
    } else if (row.isJourneyDateChangeReq === true) {
      handleShowSm();
    }
  };

  const declineRequestHandler = (row) => {
    setPassengerDetails(row);
    if (row.isPassengerChangeReq === true) {
      declineChangeHandleShows();
    } else if (row.isTicketCancelReq === true) {
      declineCanceLHandleShows();
    } else if (row.isJourneyDateChangeReq === true) {
      declineDateHandleShows();
    }
  };

  const actionFormatter = (cell, row) => {
    return !row.id ? (
      <div className="container">
        <div className="row align-items-center sm">
          <div className="col-sm">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic" variant="outline-primary">
                Action
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>
                  {" "}
                  <FcApproval size={15}></FcApproval>
                  <Button
                    variant="outline"
                    size="xs"
                    style={{ width: "100%", height: "10%" }}
                    disabled
                  >
                    Approve
                  </Button>
                </Dropdown.Item>
                <Dropdown.Item>
                  <TiTimes size={15}></TiTimes>
                  <Button
                    variant="outline"
                    size="xs"
                    style={{ width: "100%", height: "10%" }}
                    disabled
                  >
                    Decline
                  </Button>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    ) : (
      <div className="container">
        <div className="row align-items-center sm">
          <div className="col-sm">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic" variant="outline-primary">
                Action
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => acceptRequestHandler(row)}>
                  <FcApproval size={20}></FcApproval>
                  <Button
                    variant="outline"
                    size="xs"
                    style={{ width: "100%", height: "10%" }}
                  >
                    Approve
                  </Button>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => declineRequestHandler(row)}>
                  <TiTimes size={20}></TiTimes>
                  <Button
                    variant="outline"
                    size="xs"
                    style={{ width: "100%", height: "10%" }}
                  >
                    Decline
                  </Button>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    );
  };

  const requestFormatter = (cell, row) => {
    if (row.changePassengerList[0].requestType === "CHANGE_PASSANGER") {
      return "CHANGE PASSENGER";
    }
    if (row.changePassengerList[0].requestType === "CANCEL_TICKET") {
      return "CANCEL TICKET";
    }
    if (row.changePassengerList[0].requestType === "CHANGE_DOJ") {
      return "CHANGE DATE OF JOURNEY";
    }
  };

  // changeModal

  const handleCloses = () => {
    setLgShow(false);
  };

  const handleShows = () => {
    setLgShow(true);
  };

  //  decline change modal

  const declineChangeHandleCloses = () => {
    setDeclineChangeShow(false);
  };

  const declineChangeHandleShows = () => {
    setDeclineChangeShow(true);
  };
  const submitPassengerHandler = async (values) => {
    let approveBookingReq = {};
    approveBookingReq.requestType = "CHANGE_PASSANGER";
    approveBookingReq.bookingDetailId = values.id;
    approveBookingReq.remarks = values.remarks;
    approveBookingReq.bookedPassengerList = [];

    values.changePassengerList.forEach((item) => {
      let passenger = {
        passangerId: item.id,
        passengerType: item.passengerType,
        title: item.title,
        firstName: item.firstName,
        lastName: item.lastName,
        gender: item.gender,
        birthDate: item.birthDate,
      };
      approveBookingReq.bookedPassengerList.push(passenger);
    });

    const submitData = await approveRequestDetails(approveBookingReq);
    try {
      setLgShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };
  const declinePassengerHandler = async (values) => {
    let declineBookingReq = {};
    declineBookingReq.requestType = "CHANGE_PASSANGER";
    declineBookingReq.bookingDetailId = values.id;
    declineBookingReq.remarks = values.remarks;
    declineBookingReq.bookedPassengerList = [];

    values.changePassengerList.forEach((item) => {
      let passenger = {
        passangerId: item.id,
        passengerType: item.passengerType,
        title: item.title,
        firstName: item.firstName,
        lastName: item.lastName,
        gender: item.gender,
        birthDate: item.birthDate,
      };
      declineBookingReq.bookedPassengerList.push(passenger);
    });
    const submitData = await declineRequestDetails(declineBookingReq);
    try {
      setDeclineChangeShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };
  const submitCancelHandeler = async (values) => {
    let cancelBookingReq = {};
    cancelBookingReq.requestType = "CANCEL_TICKET";
    cancelBookingReq.bookingDetailId = values.id;
    cancelBookingReq.remarks = values.remarks;
    cancelBookingReq.bookedPassengerList = [];

    values.changePassengerList
      .filter((x) => x.selected)
      .forEach((item) => {
        let passengerCancel = {
          passangerId: item.id,
          passengerType: item.passengerType,
          title: item.title,
          firstName: item.firstName,
          lastName: item.lastName,
          gender: item.gender,
          birthDate: item.birthDate,
        };

        cancelBookingReq.bookedPassengerList.push(passengerCancel);
      });

    const submitData = await approveRequestDetails(cancelBookingReq);
    try {
      setShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };
  const declineCancelHandeler = async (values) => {
    let declineCancelBookingReq = {};
    declineCancelBookingReq.requestType = "CANCEL_TICKET";
    declineCancelBookingReq.bookingDetailId = values.id;
    declineCancelBookingReq.remarks = values.remarks;
    declineCancelBookingReq.bookedPassengerList = [];

    values.changePassengerList
      .filter((x) => x.selected)
      .forEach((item) => {
        let passengerCancel = {
          passangerId: item.id,
          passengerType: item.passengerType,
          title: item.title,
          firstName: item.firstName,
          lastName: item.lastName,
          gender: item.gender,
          birthDate: item.birthDate,
        };

        declineCancelBookingReq.bookedPassengerList.push(passengerCancel);
      });

    const submitData = await declineRequestDetails(declineCancelBookingReq);
    try {
      setDeclineCancelShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };
  // cancelModal

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  //  decline cancel modal

  const declineCanceLHandleCloses = () => {
    setDeclineCancelShow(false);
  };

  const declineCanceLHandleShows = () => {
    setDeclineCancelShow(true);
  };

  // Datemodal

  const handleCloseSm = () => {
    setSmShow(false);
  };

  const handleShowSm = () => {
    setSmShow(true);
  };

  //  decline date modal

  const declineDateHandleCloses = () => {
    setDeclineDateShow(false);
  };

  const declineDateHandleShows = () => {
    setDeclineDateShow(true);
  };
  const declineDateHandler = async (values) => {
    let declineDateBookingReq = {};
    declineDateBookingReq.requestType = "CHANGE_DOJ";
    declineDateBookingReq.bookingDetailId = values.id;
    declineDateBookingReq.remarks = values.remarks;
    declineDateBookingReq.dateOfJourney = values.departureDate;
    declineDateBookingReq.bookedPassengerList = [];

    let passenger = {};
    declineDateBookingReq.bookedPassengerList.push(passenger);

    const submitData = await declineRequestDetails(declineDateBookingReq);
    try {
      setDeclineDateShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };

  const columns = [
    {
      dataField: "user.normalizedUserName",
      text: "user Name",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "airportDestination.cityCode",
      text: "To",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "departureDate",
      text: "Departure Date",
      formatter: dateFormater,
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "arrivalDate",
      text: "Arrival Date",
      formatter: dateFormater,
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "requestType",
      text: "Request Type ",
      formatter: requestFormatter,
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "departureTime",
      text: "Departure Time",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "arrivalTime",
      text: "Arrival Time",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },

    {
      dataField: "action",
      text: "Action",
      formatter: actionFormatter,
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
  ];

  const rowStyle = (row) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";

    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadChangeRequest = async () => {
    const { page, sizePerPage } = tableState;

    const response = await changeRequestDetails();

    const data = response.data.data;

    const pagingData = JSON.parse(response.headers["x-pagination"]);

    setTableState(
      produce((draft) => {
        draft.page = pagingData?.CurrentPage;
        draft.data = data;
        draft.sizePerPage = pagingData?.PageSize;
        draft.dataCount = pagingData?.TotalCount;
        draft.loading = false;
      })
    );
  };

  useEffect(() => {
    loadChangeRequest();
  }, []);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setTableState(() => ({
      ...tableState,
      page,
      sizePerPage,
    }));
    setTimeout(async () => {
      await loadChangeRequest();
    }, 10);
  };

  const refreshFilter = async () => {
    loadChangeRequest();
  };
  const submitDateHandler = async (values) => {
    let dateBookingReq = {};
    dateBookingReq.requestType = "CHANGE_DOJ";
    dateBookingReq.bookingDetailId = values.id;
    dateBookingReq.remarks = values.remarks;
    dateBookingReq.dateOfJourney = values.changePassengerList[0].dateOfJourney;
    dateBookingReq.bookedPassengerList = [];

    let passenger = {};
    dateBookingReq.bookedPassengerList.push(passenger);
    console.log(values.dateOfJourney);
    const submitData = await approveRequestDetails(dateBookingReq);
    try {
      setSmShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };

  const { data, dataCount, loading } = tableState;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <div>
        <Helmet>
          <title>Change Request</title>
        </Helmet>
        <Breadcrumb routeSegments={[{ name: "Change Request" }]}></Breadcrumb>

        <div className="card card-body text-left " id="bookingHistory">
          <div>
            <div className="row mb-2 me-1 float-end">
              <button
                className="btn btn-lg btn-primary "
                onClick={() => refreshFilter()}
              >
                Refresh
              </button>
            </div>

            {/* Date Change */}
            <ApproveDate
              submitDateHandler={submitDateHandler}
              validationSchema={dateValidationSchema}
              initialValues={passengerDetails}
              approveDateShow={smShow}
              handleCloseSm={handleCloseSm}
            />

            {/*Decline Date Change */}

            <DeclineDate
              declineDateHandler={declineDateHandler}
              validationSchema={dateValidationSchema}
              initialValues={passengerDetails}
              declineDateShow={declineDateShow}
              declineDateHandleCloses={declineDateHandleCloses}
            />
            {/* Change request  */}

            <ApproveDetails
              submitPassengerHandler={submitPassengerHandler}
              validationSchema={passengerValidationSchema}
              initialValues={passengerDetails}
              approveDetailsShow={lgShow}
              approveDetailsHandleCloses={handleCloses}
            />
            {/*DECLINE  Change request  */}

            <DeclineDetails
              declinePassengerHandler={declinePassengerHandler}
              validationSchema={passengerValidationSchema}
              initialValues={passengerDetails}
              declineDetailsShow={declineChangeShow}
              declineDetailsHandleCloses={declineChangeHandleCloses}
            />
            {/* Cancel flight */}

            <ApproveCancel
              submitCancelHandeler={submitCancelHandeler}
              validationSchema={cancelValidationSchema}
              initialValues={passengerDetails}
              show={show}
              handleClose={handleClose}
            />

            {/* decline  Cancel flight */}

            <DeclineCancel
              declineCancelHandeler={declineCancelHandeler}
              validationSchema={cancelValidationSchema}
              initialValues={passengerDetails}
              show={declineCancelShow}
              handleClose={declineCanceLHandleCloses}
            />
          </div>
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            loading={loading}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </div>
    </>
  );
};

export default ChangeRequest;
